import { Component, OnInit } from '@angular/core';
import { InventoryService } from 'src/app/services/inventory-service';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'src/app/models/entry';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-article-output',
  templateUrl: './article-output.component.html',
  styleUrls: ['./article-output.component.css']
})
export class ArticleOutputComponent implements OnInit {
  loading:boolean = true;
  entry:Entry = new Entry();
  actualUser:string = "";
  actualAuthUser:string = "";

  canAuthorize:boolean = false;
  canDeliver:boolean = false;

  constructor(actRoute:ActivatedRoute, private invServ:InventoryService, private auth:AuthService) {
    actRoute.params.subscribe(params => {
      this.loadEntry(params.id);
    });
  }

  ngOnInit() {
    this.canAuthorize = this.auth.can("authorize-entry");
    this.canDeliver = this.auth.can("deliver-entry");
  }

  loadEntry(id) {
    this.loading = true;
    this.invServ.getEntry(id).then(entry => {
      this.entry = entry;
      this.actualUser = `${this.entry.user.name} ${this.entry.user.last_name}`;
      this.actualAuthUser = this.entry.authorized_by ? `${this.entry.authorized_by.name} ${this.entry.authorized_by.last_name}` : "no autorizado";
      this.loading = false;
    });
  }

  authorize() {
    this.loading = true;
    let lines = this.entry.lines.map(ln => {
      return {
        id: ln.id,
        authorized: ln.authorized,
        deliver_to: ln.deliver_to,
      }
    }).filter(ln => ln.authorized);
    this.invServ.authorizeEntryLines(lines).then(resp => {
      this.loadEntry(this.entry.id);
    });
  }

  deliver() {
    this.loading = true;
    let lines = this.entry.lines.map(ln => {
      return {
        id: ln.id,
        deliver: ln.deliver ? true : false,
      }
    }).filter(ln => ln.deliver);
    this.invServ.authorizeOutput(lines).then(resp => {
      this.loadEntry(this.entry.id);
    });
  }
}
